import React from 'react';

export const getCommonnessError = (fieldLabel: string) => (
    <>
        {fieldLabel} слишком общее. Переформулируйте его, либо подтвердите{' '}
        <a href="#brandVerificationWebsite">права на&nbsp;бренд</a>.
    </>
);
